<!-- 报废补贴 -->
<template>
  <div
    class="scrap-subsidy"
    style="width: 100%; height: 86vh; display: flex; position: relative"
  >
    <div class="select_left">
      <div class="label">统计年份</div>
      <el-select
        size="mini"
        v-model.trim="statisticsYear"
        placeholder=""
        class="work_select year_panel"
      >
        <el-option
          v-for="item in yearOptions"
          :key="item.text"
          :label="item.text"
          :value="item.text"
        ></el-option>
      </el-select>
    </div>
    <div class="left-part">
      <div class="left-part-first">
        <div class="statistics">
          <div class="statistics-title">受益户数(户)</div>
          <div
            class="statistics-number"
            :data-content="
              numberSeparatorCompute(totalStatistics.beneficiaryHouseholds || 0)
            "
          >
            {{
              (totalStatistics.beneficiaryHouseholds || 0).toFixed(0)
                | toThousandFilter
            }}
          </div>
        </div>
        <div class="statistics">
          <div class="statistics-title">补贴机具数(台)</div>
          <div
            class="statistics-number"
            :data-content="
              numberSeparatorCompute(totalStatistics.scrapMachineryCount || 0)
            "
          >
            {{
              (totalStatistics.scrapMachineryCount || 0).toFixed(0)
                | toThousandFilter
            }}
          </div>
        </div>
        <div class="statistics">
          <div class="statistics-title">机具补贴总额(万元)</div>
          <div
            class="statistics-number"
            :data-content="
              numberFloatSeparatorCompute(
                totalStatistics.scrapSubsidyAmount || 0
              )
            "
          >
            {{
              totalStatistics.scrapSubsidyAmount || 0 | toThousandFloatFilter
            }}
          </div>
        </div>
      </div>

      <div class="left-part-second">
        <TitleSlot
          title="年度各类型农机报废补贴额"
          :width="466"
          :contentHeight="252"
          backgroundImageSize="header-img-466"
          :noHeaderMargin="true"
        >
          <LeftSecond
            :scrapSubsidyList="leftSecondData"
            v-if="leftSecondData.length > 0"
          ></LeftSecond>
          <div v-else class="empty_panel"></div>
        </TitleSlot>
      </div>

      <div :class="leftThirdData.areaName.length > 0 ? 'left-part-third' : ''">
        <TitleSlot
          title="年度各区域农机报废补贴额"
          :width="466"
          :contentHeight="210"
          backgroundImageSize="header-img-466"
          :noHeaderMargin="true"
        >
          <LeftThird
            :chartData="leftThirdData"
            v-if="leftThirdData.areaName.length > 0"
            :max="max"
            :min="min"
          ></LeftThird>
          <div v-else class="empty_panel"></div>
        </TitleSlot>
      </div>

      <div class="left-part-fourth">
        <TitleSlot
          title="年度各企业农机报废补贴额"
          :width="498"
          :contentHeight="150"
          backgroundImageSize="header-img-489"
          :noHeaderMargin="true"
        >
          <LeftFourth
            :scrapSubsidyList="leftFourthData"
            v-if="leftFourthData.length > 0"
          ></LeftFourth>
          <div v-else class="empty_panel"></div>
        </TitleSlot>
      </div>
    </div>

    <div class="center-part" id="scrapCenterPart"></div>
    <div class="right-part">
      <div class="right-part-first">
        <div class="statistics-right">
          <div class="statistics-title">中央投入资金(万元)</div>
          <div
            class="statistics-number"
            :data-content="
              numberFloatSeparatorCompute(totalStatistics.centralFund || 0)
            "
          >
            {{ totalStatistics.centralFund || 0 | toThousandFloatFilter }}
          </div>
        </div>
        <div class="statistics-right">
          <div class="statistics-title">中央资金使用(万元)</div>
          <div
            class="statistics-number"
            :data-content="
              numberFloatSeparatorCompute(
                totalStatistics.centralScrapUsedFund || 0
              )
            "
          >
            {{
              totalStatistics.centralScrapUsedFund || 0 | toThousandFloatFilter
            }}
          </div>
        </div>
        <div class="statistics-right">
          <div class="statistics-title">中央结算资金(万元)</div>
          <div
            class="statistics-number"
            :data-content="
              numberFloatSeparatorCompute(
                totalStatistics.centralScrapSettlementFund || 0
              )
            "
          >
            {{
              totalStatistics.centralScrapSettlementFund ||
              0 | toThousandFloatFilter
            }}
          </div>
        </div>
      </div>

      <div :class="[fundTrend.length > 0 ? 'right-part-second' : '']">
        <TitleSlot
          title="历年投入资金变化趋势"
          :width="464"
          :contentHeight="250"
          backgroundImageSize="header-img-466"
          :noHeaderMargin="true"
        >
          <RightSecond
            :chartData="fundTrend"
            v-if="fundTrend.length > 0"
          ></RightSecond>
          <div v-else class="empty_panel"></div>
        </TitleSlot>
      </div>

      <div class="right-part-third">
        <TitleSlot
          title="中央投入资金使用/结算比例"
          :width="450"
          :contentHeight="210"
          backgroundImageSize="header-img-466"
          :noHeaderMargin="true"
        >
          <RightThird :chartData="rightThirdData"></RightThird>
        </TitleSlot>
      </div>

      <div :class="[rightFourthData.length > 0 ? 'right-part-fourth' : '']">
        <TitleSlot
          :title="`年度各月资金使用兑付情况`"
          :width="498"
          :contentHeight="162"
          backgroundImageSize="header-img-489"
          :noHeaderMargin="true"
        >
          <RightFourth
            :chartData="rightFourthData"
            v-if="rightFourthData.length > 0"
          ></RightFourth>
          <div v-else class="empty_panel"></div>
        </TitleSlot>
      </div>
    </div>

    <ChosePage class="chose-page"></ChosePage>

    <!-- 地图 -->
    <div class="map_container">
      <MapModel ref="mapModel" :areaList="areaList" :rectBounds="rectBounds" />
    </div>
  </div>
</template>

<script>
import * as purchaseAllowanceApi from "@/api/governmentAffairs/purchaseAllowance.js";
import * as scrapSubsidyApi from "@/api/governmentAffairs/scrapSubsidy.js";
import { mapGetters } from "vuex";
import TitleSlot from "../components/TitleSlot";
import ChosePage from "../components/ChosePage";
import LeftSecond from "./components/LeftSecond";
import LeftThird from "./components/LeftThird";
import LeftFourth from "./components/LeftFourth";
import RightSecond from "./components/RightSecond";
import RightThird from "./components/RightThird";
import RightFourth from "./components/RightFourth";
import MapModel from "./components/MapModel";

export default {
  components: {
    TitleSlot,
    ChosePage,
    LeftSecond,
    LeftThird,
    LeftFourth,
    RightSecond,
    RightThird,
    RightFourth,
    MapModel,
  },
  mounted() {
    const currentYear = new Date().getFullYear();
    for (let year = currentYear; year >= 2022; year--) {
      this.yearOptions.push({
        text: year,
      });
    }
    this.$nextTick(() => {
      let centerRectBounds = document
        .getElementById("scrapCenterPart")
        .getBoundingClientRect();
      this.rectBounds = {
        // 获取左侧边界
        left: centerRectBounds.left,
        // 获取右侧边界
        right: centerRectBounds.right,
        // 获取顶部边界
        top: centerRectBounds.top,
      };
      // 获取底部边界
      let chosePageBoxRectBounds = document
        .getElementById("chosePageBox")
        .getBoundingClientRect();
      this.rectBounds.bottom = chosePageBoxRectBounds.top;
    });
  },
  data() {
    return {
      commonParams: {
        year: new Date().getFullYear(),
      },
      statisticsYear: new Date().getFullYear(),
      yearOptions: [],
      // 顶部6项数据
      totalStatistics: {
        // 收益户数
        beneficiaryHouseholds: 0,
        // 补贴机具台数
        scrapMachineryCount: 0,
        // 机具补贴总额(万元)
        scrapSubsidyAmount: 0,
        // 中央资金投入
        centralFund: 0,
        // 中央资金结算
        centralScrapSettlementFund: 0,
        // 中央资金使用
        centralScrapUsedFund: 0,
      },
      // 年度各类型农机报废补贴额
      leftSecondData: [
        {
          model: "",
          scrapSubsidyAmount: 0,
        },
      ],
      // 年度各区域农机报废补贴额
      leftThirdData: {
        areaName: [],
        num: [],
      },
      // 年度各企业农机报废补贴额
      leftFourthData: [
        {
          factoryNameHuis: "",
          subsidyAmount: 0,
        },
      ],
      // 历年投入资金变化趋势
      fundTrend: [],
      // 中央投入资金使用/结算比例
      rightThirdData: {
        year: [],
        // 使用比例
        useRatio: [],
        // 结算比例
        settlementRatio: [],
      },
      // 年度各月资金使用兑付情况
      rightFourthData: [],
      // 各区域报废补贴地图
      areaList: {},
      timer: null,
      // 年度各区域农机报废补贴额 最大值
      max: 10,
      // 年度各区域农机报废补贴额 最小值
      min: 0,
      // 弹窗显示边界值对象
      rectBounds: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
      },
    };
  },
  watch: {
    statisticsYear: {
      handler(val) {
        this.commonParams.year = val;
        this.initPageData();
        this.getLastUpdateTime();
        this.getSubsidyRatio();
      },
    },
    "$store.state.activeRegionObj": {
      deep: true,
      immediate: true,
      handler(val) {
        if (!val.areaCode) return;
        this.isProvinceLevel = val.areaCode == "410000000";
        this.initPageData();
        this.getLastUpdateTime();
        this.getSubsidyRatio();
        // const city = val.areaCode.slice(0, -3);
        this.$nextTick(() => {
          if (this.$refs.mapModel) {
            this.$refs.mapModel.addProvince(val.areaCode);
          }
        });
      },
    },
    "$store.state.activeYear": {
      // deep: true,
      // immediate: true,
      handler(val) {
        this.commonParams.year = val;
        this.initPageData();
      },
    },
  },
  computed: {
    ...mapGetters(["getActiveYear"]),
    numberSeparatorCompute() {
      return function (number) {
        let regex = /(?!^)(?=(\d{3})+(\.|$))/g;
        if (!number) {
          return 0;
        } else {
          return number.toFixed().replace(regex, ",");
        }
      };
    },
    numberFloatSeparatorCompute() {
      return function (number) {
        return number.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      };
    },
  },
  name: "scrapSubsidy",
  methods: {
    initPageData() {
      this.getStatistic();
      this.getScrapSubsidy();
      this.getAraeSubsidy();
      this.getEnterpriseSubsidy();
      this.getSubsidyByYear();
      this.getSubsidyUseByYear();
      this.getCompanyDistribute();
    },
    //获取最后一次跟新时间
    getLastUpdateTime() {
      purchaseAllowanceApi.getLastUpdateTime("BF").then((res) => {
        this.$store.dispatch("setLastUpdateTime", res || "");
      });
    },
    // 仪表盘-各区域年度补贴机具数量统计 (顶部6项数据)
    getStatistic() {
      scrapSubsidyApi.getStatistic(this.commonParams).then((res) => {
        this.totalStatistics = res;
      });
    },
    // 年度各类型农机报废补贴额
    getScrapSubsidy() {
      scrapSubsidyApi.getScrapSubsidy(this.commonParams).then((res) => {
        const result = Object.assign([], res);
        let tempArr = [];
        for (let i = 0; i < result.length; i += 2) {
          const obj = { left: result[i] };
          if (i + 1 < result.length) obj.right = result[i + 1];
          tempArr.push(obj);
        }
        this.leftSecondData = tempArr;
      });
    },
    // 各区域农机报废补贴额
    getAraeSubsidy() {
      scrapSubsidyApi.getAraeSubsidy(this.commonParams).then((res) => {
        let tempArr = Object.assign([], res);
        let that = this;
        let max = 10;
        this.leftThirdData.areaName = [];
        this.leftThirdData.num = [];

        if (tempArr && tempArr.length > 0) {
          tempArr.forEach((item) => {
            this.leftThirdData.areaName.push(item.area);
            this.leftThirdData.num.push(item.scrapSubsidyAmount);
          });
          max = Math.max(...this.leftThirdData.num);
          let nums = this.leftThirdData.num;
          if (max != 0) {
            for (let i = 0; i < nums.length; i++) {
              if (nums[i] == 0) {
                nums[i] = 0.01;
              }
            }
          } else {
            max = 10;
          }
          this.max = Math.round(max * 1.1);
          if (this.leftThirdData.areaName.length > 7) {
            if (this.timer) {
              clearTimeout(this.timer);
            }
            this.timer = setInterval(function () {
              that.leftThirdData.areaName.push(
                that.leftThirdData.areaName.shift()
              );
              that.leftThirdData.num.push(that.leftThirdData.num.shift());
            }, 5000);
          }
        }
      });
    },
    // 年度各企业农机报废补贴额
    getEnterpriseSubsidy() {
      scrapSubsidyApi.getEnterpriseSubsidy(this.commonParams).then((res) => {
        const result = Object.assign([], res);
        let tempArr = [];
        for (let i = 0; i < result.length; i += 2) {
          const obj = { left: result[i] };
          if (i + 1 < result.length) obj.right = result[i + 1];
          tempArr.push(obj);
        }
        this.leftFourthData = tempArr;
      });
    },
    // 历年投入资金变化趋势
    getSubsidyByYear() {
      scrapSubsidyApi.getSubsidyByYear(this.commonParams).then((res) => {
        let tempArr = Object.assign([], res);
        tempArr.forEach((item) => {
          item.centralFund = item.centralFund || 0;
        });
        this.fundTrend = tempArr;
      });
    },
    // 中央投入资金使用/结算比例
    getSubsidyRatio() {
      scrapSubsidyApi.getSubsidyRatio(this.commonParams).then((res) => {
        let tempArr = Object.assign([], res);
        let year = [];
        let useRatio = [];
        let settlementRatio = [];
        tempArr.forEach((item) => {
          year.push(item.year);
          useRatio.push(item?.centralSubsidyUseRatio?.toFixed(2) || 0.0);
          settlementRatio.push(
            item?.centralSubsidySettlementRatio?.toFixed(2) || 0.0
          );
        });
        this.rightThirdData.year = year.reverse();
        this.rightThirdData.useRatio = useRatio.reverse();
        this.rightThirdData.settlementRatio = settlementRatio.reverse();
      });
    },
    // 年度各月资金使用兑付情况
    getSubsidyUseByYear() {
      scrapSubsidyApi.getSubsidyUseByYear(this.commonParams).then((res) => {
        this.rightFourthData = res || [];
        this.rightFourthData.reverse();
      });
    },
    // 各区域报废补贴地图
    getCompanyDistribute() {
      scrapSubsidyApi.getCompanyDistribute(this.commonParams).then((res) => {
        this.areaList = res;
      });
    },
  },
};
</script>
<style scoped lang="scss">
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}
.select_left {
  display: flex;
  position: absolute;
  top: vh(40);
  left: vw(696);
  z-index: 10;
  border-radius: vw(4);
  background-color: #0a441f;
  border: 1px solid #7dab83;
  .label {
    width: vw(72);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: fontSize(14);
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    background-color: #2f7b5f;
    border-top-left-radius: vw(4);
    border-bottom-left-radius: vw(4);
  }
}
::v-deep {
  .year_panel {
    width: vw(84);
    padding: 0;
    .el-input__inner {
      padding: 0 vw(20) 0 vw(18);
      height: vh(28);
      line-height: vh(28);
      text-align: left;
    }
    .el-input__suffix {
      right: vw(10);
    }
  }
}
.scrap-subsidy {
  margin-top: vh(-40);
}
::v-deep.left-part {
  width: vw(512);
  margin-left: vw(10);
  z-index: 100;
  .left-part-first {
    display: flex;
    align-items: center;
    width: vw(488);
    height: vh(92);
    margin-left: vw(6);
    padding: 0 vw(20);
    background-image: url("../../../assets/images/governmentAffairs/common/bg_bata.png");
    background-size: vw(488) vh(92);
    background-repeat: no-repeat;
    font-family: Microsoft YaHei;
    font-size: fontSize(14);
    color: #ffffff;
    .statistics {
      margin-right: vw(56);
      .statistics-title {
        width: vw(107);
        height: vh(24);
        line-height: vh(24);
        padding-left: vw(10);
        background-image: url("../../../assets/images/governmentAffairs/common/bg_num.png");
      }
      .statistics-number {
        position: relative;
        margin-top: vh(6);
        margin-left: vw(10);
        font-family: "Rajdhani-Bold";
        font-weight: 600;
        font-size: fontSize(26);
        font-style: italic;
        // background: linear-gradient(180deg, #FFFFFF 35.009765625%, #BDFFCC 100%);
        // -webkit-background-clip: text;
        // -webkit-text-fill-color: transparent;
      }
      .statistics-number::before {
        content: attr(data-content);
        position: absolute;
        top: 0;
        left: 0;
        color: transparent;
        text-shadow: 0 0 15px rgba(82, 242, 136, 1); /* 第四层阴影 */
      }
      .statistics-number::after {
        content: attr(data-content);
        position: absolute;
        top: 0;
        left: 0;
        color: transparent;
        background: linear-gradient(180deg, #ffffff 50%, #bdffcc 60%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      &:nth-child(2) {
        margin-right: vw(48);
      }
      &:nth-child(3) {
        .statistics-title {
          width: vw(140);
        }
      }
    }
  }

  .left-part-third {
    background: url("../../../assets/images/governmentAffairs/scrapSubsidy/bg_chart_zz_bfbt.png")
      no-repeat;
    background-position: 42% 91%;
    background-size: 76%;
  }
}

.center-part {
  flex: 1;
}

.right-part {
  width: vw(505);
  margin-right: vw(8);
  z-index: 100;
  .right-part-first {
    display: flex;
    align-items: center;
    width: vw(488);
    height: vh(92);
    margin-left: vw(6);
    padding: 0 vw(20);
    background-image: url("../../../assets/images/governmentAffairs/common/bg_bata.png");
    background-size: vw(488) vh(92);
    background-repeat: no-repeat;
    font-family: Microsoft YaHei;
    font-size: fontSize(14);
    color: #ffffff;
    .statistics-right {
      margin-right: vw(19);
      .statistics-title {
        width: vw(140);
        height: vh(24);
        line-height: vh(24);
        padding-left: vw(10);
        background-image: url("../../../assets/images/governmentAffairs/common/bg_num.png");
      }
      .statistics-number {
        position: relative;
        margin-top: vh(6);
        margin-left: vw(10);
        font-weight: 600;
        font-size: fontSize(26);
        font-style: italic;
        // background: linear-gradient(180deg, #FFFFFF 35.009765625%, #BDFFCC 100%);
        // -webkit-background-clip: text;
        // -webkit-text-fill-color: transparent;
      }
      .statistics-number::before {
        content: attr(data-content);
        position: absolute;
        top: 0;
        left: 0;
        color: transparent;
        text-shadow: 0 0 15px rgba(82, 242, 136, 1); /* 第四层阴影 */
      }
      .statistics-number::after {
        content: attr(data-content);
        position: absolute;
        top: 0;
        left: 0;
        color: transparent;
        background: linear-gradient(180deg, #ffffff 50%, #bdffcc 60%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
  }

  .right-part-second {
    margin-left: vw(22);
    background: url("../../../assets/images/governmentAffairs/scrapSubsidy/bg_chart_line_bhqs.png")
      no-repeat;
    background-position: 58% 92%;
    background-size: 84%;
  }
  .right-part-third {
    margin-left: vw(21);
    background: url("../../../assets/images/governmentAffairs/scrapSubsidy/bg_chart_hzz_bl.png")
      no-repeat;
    background-position: 12% 98%;
    background-size: 95%;
  }
  .right-part-fourth {
    background: url("../../../assets/images/governmentAffairs/purchaseAllowance/pic_chart_dzs_line.png")
      no-repeat;
    background-position: 76% 92%;
    background-size: 89%;
  }
}

.chose-page {
  position: absolute;
  bottom: vh(92);
  left: vw(785);
  width: vw(530);
  height: vh(116);
  z-index: 1;
}

.map_container {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  width: 100%;
  background: url("../../../assets/images/governmentAffairs/purchaseAllowance/bg.gif")
    no-repeat;
  background-size: 100% 100%;
}
</style>
